import IndexAdmin from "@/views/pages/admin/IndexAdmin.vue";

export default [
    {
        path: '',
        name: 'AdminIndex',
        component: IndexAdmin,
        meta: {
            title: 'Moje konto'
        }
    },
    {
        path: 'categories',
        name: 'AdminCategories',
        component: () => import('@/views/pages/admin/categories/Index.vue'),
        meta: {
            title: 'Kategorie'
        }
    },
    {
        path: 'users',
        name: 'AdminUsers',
        component: () => import('@/views/pages/admin/users/Index.vue'),
        meta: {
            title: 'Użytkownicy'
        }
    },
    {
        path: 'users/:id',
        name: 'AdminUserDetails',
        component: () => import('@/views/pages/admin/users/Show.vue')
    },
    {
        path: 'settings',
        name: 'AdminSettings',
        component: () => import('@/views/pages/admin/settings/Index.vue'),
        meta: {
            title: 'Ustawienia'
        }
    },
    {
        path: 'payments',
        name: 'AdminPayments',
        component: () => import('@/views/pages/admin/payments/Index.vue'),
        meta: {
            title: 'Płatności'
        }
    },
    {
        path: 'opinions',
        name: 'AdminOpinions',
        component: () => import('@/views/pages/admin/opinions/Index.vue'),
        meta: {
            title: 'Opinie'
        }
    },
    {
        path: 'mail-contents',
        name: 'AdminMailContents',
        component: () => import('@/views/pages/admin/mail-contents/Index.vue'),
        meta: {
            title: 'Szablony email'
        }
    }
]
